import { useCallback, useEffect, useState } from "react";

const useCaptchaAudio = (sid) => {
  const [status, setStatus] = useState("");

  // stop audio when the component using this hook goes away
  useEffect(() => () => window.speechSynthesis.cancel(), []);

  const stop = useCallback(() => {
    window.speechSynthesis.cancel();
    setStatus("");
  }, []);

  const speak = useCallback(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_PUBLIC_URL}/captcha/audio?captcha_sid=${sid}`,
      );
      if (!res.ok) throw new Error("audio failed");
      const text = await res.text(); // e.g. "A T K 8 m b"
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-IN";
      utterance.rate = 0.6;
      window.speechSynthesis.speak(utterance);
      setStatus("Playing CAPTCHA audio");
    } catch {
      setStatus("Audio unavailable. Please refresh the CAPTCHA.");
    }
  }, [sid]);

  return { speak, stop, status };
};

export default useCaptchaAudio;
